import styled from 'styled-components';
import { setAlpha } from '../../styles';
import { VStack } from '../Core';

export const InsightContainer = styled(VStack)`
  padding: ${({ theme }) => theme.spacing8}px;
  border: solid 1px ${({ theme }) => setAlpha(0.01, theme.backgroundCard)};
  background: ${({ theme }) => theme.backgroundCard};
`;
